import data from '@/data/data.ts'
import nl from '@/data/nl.ts'
import en from '@/data/en.ts'

import { GetterTree } from 'vuex'
import { State } from '.'
import { Languages } from '@/enums'

const getters: GetterTree<any, any> = {
	branches(state: State): any {
		return data.branches
	},
	crimes(state: State): any {
		return data.crimes
	},
	punishments(state: State): any {
		return data.punishments
	},
	infoScreens(state: State): any {
		switch (state.language) {
			case Languages.NL:
				return nl.infoScreens
			case Languages.EN:
				return en.infoScreens
			default:
				return nl.infoScreens
		}
	},
	user(state: State): any {
		return state.user
	},
	trackResults(state: State): boolean {
		return state.trackResults
	},
	pageTexts(state: State): any {
		switch (state.language) {
			case Languages.NL:
				return nl.pageTexts
			case Languages.EN:
				return en.pageTexts
			default:
				return nl.pageTexts
		}
	},
	language(state: State): Languages {
		return state.language
	},
}

export default getters
